module.exports = __webpack_public_path__ + "img/icn_scarpa_edit_2_selezionata.d2696b0e.png";